/** @format */

import React from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
// import ServiceContentLayout from 'components/ServiceContentLayout';
// import ArticleLayout from 'components/ArticleLayout';
import ServiceContentLayout from 'components/ServiceContentLayoutTest';
import Container from 'react-bootstrap/Container';
import { LeadsSectionBody, LeadSources } from 'components/LeadsGenerator';

import './styles.scss';

export default function TestLeadServiceArticlePage(props) {
  const text = props.t('lang_registration:visningsklar_article');
  const { isMobileView } = props;

  // useEffect(() => {
  //   document.getElementById('main-container').classList.add('no-boundry');

  //   return () => {
  //     document.getElementById('main-container').classList.remove('no-boundry');
  //   };
  // }, []);

  const MainTextContent = () => {
    return (
      <div className='main-text-content'>
        <h2 className='articlepage-main-title'>{text.heading}</h2>

        <p>
          Alltid redo för visning. Vi tar hand om allt från renovering,
          <br />
          trädgårdsfix till städning och styling.
        </p>

        <span>Kontakta teamet</span>
        <span>0709202492</span>
        <span>Visningsklar@friamaklare.se</span>
      </div>
    );
  };

  return (
    <>
      <div className='main-container test-leads-article-page-container'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <ServiceContentLayout
              text={text}
              isMobileView={isMobileView}
              banner={'images/visni-top-no-text.png'}
              subIcon={'images/visni-2.png'}
              subIcon1={'images/visni-3.png'}
              // showFocusButtons={true}
              MainTextContent={MainTextContent}
              LeadsForm={() => (
                <LeadsSectionBody
                  metadata={{
                    source: LeadSources.FM_READY_TO_VIEW
                  }}
                  showPropertyTypes={true}
                  showUrgency={true}
                  showTextInputs={true}
                  showLeadTypes={true}
                  showBrokerStatusSelector={true}
                  showAddressInput={true}
                  showSquareMeterInput={true}
                  showNumberOfRoomsInput={true}
                  showTelephoneInput={true}
                  isMultiStage={true}
                  {...props}
                />
              )}
            />
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
